module.exports = __webpack_public_path__ + "static/footer-ibis-logo-88e460571ade4b64bfed7920a750b326.svg";